import * as Sentry from "@sentry/react";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { DATA_PRODUCER_TABLE_NAME, NAME_IDX } from "./constants";

const RANGE_TO_BE_UNLOCKED = "E2:M";
const COLUMNS_UNLOCKED = 9;

export const lockEditModeInSomeColumns = async () => {
  try {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
      const dataProducerTable = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);
      worksheet.load("isNullObject");
      dataProducerTable.load(["isNullObject", "columns"]);
      await context.sync();

      if (worksheet.isNullObject || dataProducerTable.isNullObject) return;

      worksheet.protection.unprotect();

      const rowsRange = dataProducerTable.columns.getItem(NAME_IDX).getDataBodyRange();
      rowsRange.load("values");
      await context.sync();

      const rowsQuantity = rowsRange.values.length;

      const columnsToBeUnlocked = worksheet.getRange(RANGE_TO_BE_UNLOCKED + (rowsQuantity + 1));

      const cellProperty: Excel.SettableCellProperties = {
        format: { protection: { locked: false } },
      };

      const cellProperties = Array(rowsQuantity).fill([...Array(COLUMNS_UNLOCKED).fill(cellProperty)]);

      columnsToBeUnlocked.setCellProperties(cellProperties);

      await protectDataProducerSheet({ worksheet });

      await context.sync();
    });
  } catch (error) {
    Sentry.captureException(
      new Error('Error while locking edit mode in some columns', { cause: error })
    );
  }
};

export const protectDataProducerSheet = async ({ worksheet }: { worksheet?: Excel.Worksheet }) => {
  if (!worksheet) {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
      worksheet.load("isNullObject");
      await context.sync();

      if (worksheet.isNullObject) {
        return;
      }

      await protectDataProducerSheet({ worksheet });
    });

    return;
  }

  worksheet.protection.protect({
    allowAutoFilter: true,
    allowDeleteColumns: false,
    allowDeleteRows: false,
    allowFormatCells: true,
    allowFormatColumns: true,
    allowFormatRows: true,
    allowInsertColumns: true,
    allowInsertHyperlinks: true,
    allowInsertRows: true,
    allowPivotTables: true,
    allowSort: true,
  });
};
